import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-patient-profile-link',
  templateUrl: './patient-profile-link.component.html',
  styleUrls: ['./patient-profile-link.component.scss'],
  standalone: false,
})
export class PatientProfileLinkComponent {
  @Input() name: string | null | undefined;
  @Input() patientId: string | number | null | undefined;
  @Input() profileRoute: string | null | undefined;
  @Input() subtitle: string | null | undefined;
  @Input() subtitleIcon: string | null | undefined;
  @Input() showAvatar = true;
  @Input() compact = false;
  @Input() mobileNameOnly = false;
  @Output() profileOpened = new EventEmitter<void>();

  get displayName(): string {
    return String(this.name || '').trim() || 'Paciente sin nombre';
  }

  get initials(): string {
    return (
      this.displayName
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((part) => part.charAt(0).toUpperCase())
        .join('') || '--'
    );
  }

  get route(): string | any[] | null {
    if (this.profileRoute) return this.profileRoute;
    if (this.patientId === null || this.patientId === undefined || this.patientId === '') {
      return null;
    }
    return ['/patients', this.patientId];
  }

  stopRowAction(event: MouseEvent): void {
    event.stopPropagation();
    this.profileOpened.emit();
  }
}
